module.exports = __webpack_public_path__ + "static/img/logo.1190a0b1.svg";